import ChangePassword from "./ChangePassword"

export default  ChangePassword;



// WEBPACK FOOTER //
// ./src/components/App/ChangePassword/index.js